import React from 'react';
import { Flex } from 'antd';

import { AISwitcher } from '../components/AISwitcher';
import * as S from '../styles/Common.styles';
import { optionsSwitch } from '../utils/switcherOptions';
import { SuggestionsContainer } from '../containers/SuggestionsContainer';
import { PromptEditContainer } from '../containers/PromptEditContainer';
import { Page } from '../../../../../shared/ui/Page';

export const AIAssistantPage = () => {
    return (
        <Page isBackButton title={'ИИ профиль'}>
            <Flex vertical gap={24}>
                {optionsSwitch.map((option, index) => (
                    <AISwitcher key={index} {...option} />
                ))}

                <PromptEditContainer />
                <S.Divider />
                <SuggestionsContainer />
            </Flex>
        </Page>
    );
};
